export const reactionColors = {
  like: { foreground: '#FFF', background: '#3D70FF' },
  love: { foreground: '#FDE1D4', background: '#DE2A2F' },
  applause: { foreground: '#DFF9DA', background: '#348946' },
  support: { foreground: '#F8DCE4', background: '#763462' },
};
